import script from "./MPModalDetalle.vue?vue&type=script&setup=true&lang=js"
export * from "./MPModalDetalle.vue?vue&type=script&setup=true&lang=js"

import "./MPModalDetalle.vue?vue&type=style&index=0&id=ac96367a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac96367a"]])

export default __exports__